import { Injectable } from '@angular/core';
import { environment as Env } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private config;
  constructor() 
  {
    this.config = Env
  }

  getApiEndPoint()
  {
    return this.config['apiEndPoint'];
  }
}
